'use client';

import { Button } from '@shared/components/shadcn';
import { Reminder } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { useFormContext } from 'react-hook-form';
import { useMultistepForm } from '../../../../../form-controls/MultistepForm/hooks/useMultistepForm';

function ConfirmationStep() {
  const t = useTranslations('my_account.settings.account_review_reminder_sheet');
  const { watch } = useFormContext();
  const { goToNextStep } = useMultistepForm();
  const interval = watch('interval');

  const handleDone = async () => {
    await goToNextStep();
  };

  return (
    <div
      className="flex flex-col flex-1 min-h-0 gap-8 px-6 py-4"
      data-track-container="Account Review Reminder Confirmed"
      data-track-value={t(`options.${interval}`)}
      data-testid="account-review-reminder-confirmation-step"
    >
      <div className="flex flex-col gap-5 items-start justify-center w-full">
        <Reminder size="extra-extra-large" data-testid="reminder-icon" />
        <div className="flex flex-col gap-2 items-start justify-start w-full">
          <h4 className="w-full" data-testid={`account-review-reminder-confirmation-interval-${interval.toLowerCase()}`}>
            {t('confirmation', {
              interval: t(`confirmation_intervals.${interval}`),
            })}
          </h4>
        </div>
      </div>

      <div className="mt-auto pt-4" data-track-container="Actions">
        <Button className="w-full" onClick={handleDone} data-testid="account-review-reminder-done-button" data-track-name="Done">
          {t('done')}
        </Button>
      </div>
    </div>
  );
}

export { ConfirmationStep };
